import { fromNullable, Option, some } from 'fp-ts/lib/Option';
import { useEffect, useState } from 'react';

const fallbackCountryCode = 'GB';

export default function useCountryCode(
  explicitCountryCode: Option<string>
): Option<string> {
  const [countryCode, setCountryCode] = useState<Option<string>>(
    explicitCountryCode
  );

  useEffect(() => {
    if (countryCode.isSome()) return;

    const fail = () => setCountryCode(some(fallbackCountryCode));

    const el = document.querySelector('[data-jg-client-chrome]');
    if (!el) {
      fail();
      return;
    }

    const src = el.getAttribute('src');
    if (!src) {
      fail();
      return;
    }

    (async () => {
      try {
        const response = await fetch(src);
        const header = response.headers.get('X-Country-Code');
        if (!header) {
          fail();
          return;
        }

        setCountryCode(fromNullable(header.split(/\s*,\s*/)[0]));
      } catch {
        fail();
      }
    })();
  }, [countryCode]);

  return countryCode;
}
